import React, { useEffect } from 'react';
import { useComunicacao } from '../contexts/ComunicacaoContext';
import ListaCanais from '../components/comunicacao/ListaCanais';
import AreaTopicos from '../components/comunicacao/AreaTopicos';
import DetalhesTopico from '../components/comunicacao/DetalhesTopico';
import { toast } from 'react-toastify';

const ComunicacaoPage: React.FC = () => {
  const { carregarCanais, selecionarCanal, selecionarTopico, topicoSelecionado } = useComunicacao();

  useEffect(() => {
    carregarCanais();
  }, [carregarCanais]);

  // Abre automaticamente o canal/tópico vindo de um link de email
  // (?canalId=...&topicoId=...), igual ao que já existe para tarefas.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const canalId = params.get('canalId');
    const topicoId = params.get('topicoId');

    if (canalId || topicoId) {
      (async () => {
        try {
          if (canalId) {
            await selecionarCanal(canalId);
          }
          if (topicoId) {
            await selecionarTopico(topicoId);
          }
        } catch (error) {
          console.error('Erro ao abrir tópico/canal a partir do link de email:', error);
          toast.error('Erro ao abrir o tópico');
        } finally {
          const url = new URL(window.location.href);
          url.searchParams.delete('canalId');
          url.searchParams.delete('topicoId');
          window.history.replaceState(null, '', url.pathname + url.search + url.hash);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-[calc(100vh-4rem)] bg-gray-50">
      <ListaCanais />
      <div className="flex-1 flex flex-col overflow-hidden">
        {topicoSelecionado ? <DetalhesTopico /> : <AreaTopicos />}
      </div>
    </div>
  );
};

export default ComunicacaoPage;
